import axios from "axios";
import moment from "moment";
import has from "lodash/has";
import {takeLatest, call, put, select, all} from "redux-saga/effects";
import {createAction} from "redux-actions";
import FUNNEL_CONSTANTS from "../../../constants";
import formatIntroFunnelChartData from "../../../functions/formatIntroFunnelChartData";
import combineStats from "../../../functions/combineStats";
import CONSTANTS from "../../../constants";

export const SET_LOADING = "saga/SET_LOADING";
export const SET_TABLES_LOADING = "saga/SET_TABLES_LOADING";
export const SET_DATES = "saga/SET_DATES";
export const UPDATE_DATES = "saga/UPDATE_DATES";
export const UPDATE_TABLES = "saga/UPDATE_TABLES";

export const FETCH_TABLE_DATA = "saga/FETCH_TABLE_DATA";
export const FETCH_TABLE_DATA_SUCCESS = "saga/FETCH_TABLE_DATA_SUCCESS";

export const FETCH_FUNNEL_CHART_SUCCESS = "saga/FETCH_FUNNEL_CHART_SUCCESS";
export const FETCH_FUNNEL_INTRO_OFFERS_CHART_SUCCESS = "saga/FETCH_FUNNEL_INTRO_OFFERS_CHART_SUCCESS";
export const FETCH_FUNNEL_CHART_FAILURE = "saga/FETCH_FUNNEL_CHART_FAILURE";
export const FETCH_REFERRAL_TABLE_SUCCESS = "saga/FETCH_REFERRAL_TABLE_SUCCESS";
export const FETCH_REFERRAL_TABLE_FAILURE = "saga/FETCH_REFERRAL_TABLE_FAILURE";
export const RESET_REFERRAL_TABLE = "saga/RESET_REFERRAL_TABLE";
export const UPDATE_CUSTOM_RANGE = "sagas/UPDATE_CUSTOM_RANGE";
export const UPDATE_CHART = "sagas/UPDATE_CHART";
export const UPDATE_START_FROM = "sagas/UPDATE_START_FROM";
export const TOGGLE_LOOSE = "sagas/TOGGLE_LOOSE";
export const TOGGLE_FUTURE_APPOINTMENT = "sagas/TOGGLE_FUTURE_APPOINTMENT";

export const SET_START_FROM = "sagas/SET_START_FROM";
export const SET_START_FROM_APPOINTMENT = "sagas/SET_START_FROM_APPOINTMENT";
export const SET_TOGGLE_LOOSE = "sagas/SET_TOGGLE_LOOSE";
export const SET_TOGGLE_FUTURE_APPOINTMENT = "sagas/SET_TOGGLE_FUTURE_APPOINTMENT";
export const ADD_ALL_TIME_RANGE_SUCCESS = "sagas/ADD_ALL_TIME_RANGE_SUCCESS";
export const SET_SHOW_FUTURE_APPOINTMENT = "sagas/SET_SHOW_FUTURE_APPOINTMENT";

// const axios = defaultNetworkService()
export const actionCreators = {
  fetchTableData: createAction(FETCH_TABLE_DATA),
  updateDates: createAction(UPDATE_DATES),
  updateChart: createAction(UPDATE_CHART),
  updateStartFrom: createAction(UPDATE_START_FROM),
  toggleLoose: createAction(TOGGLE_LOOSE),
  toggleFutureAppointment: createAction(TOGGLE_FUTURE_APPOINTMENT),
  requestNewTableData: createAction(UPDATE_TABLES),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE)
};

export default function* watchSummary() {
  yield takeLatest(FETCH_TABLE_DATA, getTableData);
  yield takeLatest(UPDATE_CHART, updateChart);
  yield takeLatest(UPDATE_START_FROM, updateStartFrom);
  yield takeLatest(TOGGLE_FUTURE_APPOINTMENT, toggleFutureAppointment);
  yield takeLatest(TOGGLE_LOOSE, toggleLoose);
}

let startDate;
let endDate;

function getStartFromApiValue(startFrom) {
  if (typeof startFrom === "boolean") {
    switch (startFrom) {
      case false:
        return FUNNEL_CONSTANTS.START_FROM_OPTIONS.LEAD;
      case true:
        return FUNNEL_CONSTANTS.START_FROM_OPTIONS.APPOINTMENT;
      default:
        return FUNNEL_CONSTANTS.START_FROM_OPTIONS.INTRO_OFFER;
    }
  } else {
    switch (startFrom) {
      case FUNNEL_CONSTANTS.START_FROM_OPTIONS.LEAD:
        return false;
      case FUNNEL_CONSTANTS.START_FROM_OPTIONS.APPOINTMENT:
        return true;
      default:
        return false;
    }
  }
}

export function* getTableData(tablePayload) {
  yield put({type: SET_LOADING, payload: true});
  yield put({type: FETCH_TABLE_DATA_SUCCESS, payload: tablePayload.payload});

  yield put({type: SET_START_FROM, payload: getStartFromApiValue(tablePayload.payload.params.startFromAppointment)});
  yield put({type: SET_SHOW_FUTURE_APPOINTMENT, payload: tablePayload.payload.params.showFutureAppointmentByDefault});

  const {
    currentUser: {organization_id, current_object_id, current_location_id, current_region_id, calendarEndDate},
    startFrom,
    toggleLoose,
    toggleFutureAppointment
  } = yield select(state => state.funnelChart);

  startDate = moment(calendarEndDate)
    .startOf("month")
    .format("YYYY-MM-DD");
  endDate = calendarEndDate;

  yield put({type: SET_DATES, payload: {startDate: startDate, endDate: endDate}});

  const data = {
    organization_id,
    object_id: current_object_id,
    location_id: current_location_id,
    region_id: current_region_id,
    start_date: startDate,
    end_date: endDate,
    start_from_appointment: getStartFromApiValue(startFrom),
    purchases_in_conversion: toggleLoose,
    show_future_appointment: toggleFutureAppointment
  };

  try {
    yield requestByStartFrom(startFrom, data);
    yield put({type: SET_LOADING, payload: false});
  } catch (error) {
    console.error(error);
  }
}

function* requestByStartFrom(startFrom, data) {
  switch (startFrom) {
    case FUNNEL_CONSTANTS.START_FROM_OPTIONS.LEAD:
      yield all([fetchFunnelChartData(data), fetchReferralTableData(data)]);
      break;
    case FUNNEL_CONSTANTS.START_FROM_OPTIONS.APPOINTMENT:
      yield fetchFunnelChartData(data);
      yield put({type: RESET_REFERRAL_TABLE});
      yield put({type: SET_START_FROM_APPOINTMENT, payload: true});
      break;
    case FUNNEL_CONSTANTS.START_FROM_OPTIONS.INTRO_OFFER:
      yield fetchFunnelIntroOfferChartData(data);
      yield put({type: RESET_REFERRAL_TABLE});
      break;
  }
}

function* getRequestData() {
  const {
    currentUser: {organization_id, current_object_id, current_location_id, current_region_id},
    selectedRequestDates: {startDate, endDate},
    startFrom,
    toggleLoose,
    toggleFutureAppointment
  } = yield select(state => state.funnelChart);

  return {
    organization_id,
    object_id: current_object_id,
    location_id: current_location_id,
    region_id: current_region_id,
    start_date: startDate,
    end_date: endDate,
    startFrom,
    start_from_appointment: getStartFromApiValue(startFrom),
    purchases_in_conversion: toggleLoose,
    show_future_appointment: toggleFutureAppointment
  };
}

export function* updateStartFrom(payload) {
  yield put({type: SET_START_FROM, payload: payload.payload});
}

export function* toggleFutureAppointment(payload) {
  yield put({type: SET_TOGGLE_FUTURE_APPOINTMENT, payload: payload.payload});
  yield put({type: SET_TABLES_LOADING, payload: true});

  const data = yield getRequestData();

  const allSagas = [fetchFunnelChartData({...data}), fetchReferralTableData({...data})];
  try {
    // effects will get executed in parallel
    yield all(allSagas);
    yield put({type: SET_TABLES_LOADING, payload: false});
  } catch (error) {
    console.error(error);
  }
}

export function* toggleLoose(payload) {
  yield put({type: SET_TOGGLE_LOOSE, payload: payload.payload});
  yield put({type: SET_TABLES_LOADING, payload: true});

  const data = yield getRequestData();

  try {
    yield requestByStartFrom(data.startFrom, data);

    yield put({type: SET_TABLES_LOADING, payload: false});
  } catch (error) {
    console.log("updateChart", error);
  }
}

export function* updateChart() {
  yield put({type: SET_TABLES_LOADING, payload: true});

  const data = yield getRequestData();

  try {
    yield requestByStartFrom(data.startFrom, data);

    yield put({type: SET_TABLES_LOADING, payload: false});
  } catch (error) {
    console.log("updateChart", error);
  }
}

export function* updateDates(payload) {
  yield put({type: UPDATE_DATES, payload: payload});
}

/**
 * REQUESTS TO THE SERVER
 */
export function* fetchFunnelChartData(args) {
  const {
    organization_id,
    object_id,
    location_id,
    region_id,
    start_date,
    end_date,
    start_from_appointment,
    purchases_in_conversion,
    show_future_appointment
  } = args;

  try {
    const url = {
      href: CONSTANTS.REQUEST_HREF.FUNNEL_LASER_CHART,
      params: {
        organization_id,
        object_id,
        location_id,
        region_id,
        start_date,
        end_date,
        start_from_appointment,
        purchases_in_conversion,
        show_future_appointment
      }
    };

    const res = yield call(axios.get, url.href, {
      params: url.params
    });

    if (!res) {
      return;
    }
    if (has(res, "data.first_data_date")) {
      yield put({type: ADD_ALL_TIME_RANGE_SUCCESS, payload: res.data.first_data_date});
    }
    yield put({type: FETCH_FUNNEL_CHART_SUCCESS, payload: res.data});
  } catch (error) {
    console.error(error);
    yield put({type: FETCH_FUNNEL_CHART_FAILURE, error});
  }
}

export function* fetchFunnelIntroOfferChartData(args) {
  const {organization_id, object_id, location_id, region_id, start_date, end_date, purchases_in_conversion} = args;

  try {
    const url = {
      href: CONSTANTS.REQUEST_HREF.FUNNEL_INTRO_OFFER,
      params: {
        organization_id,
        object_id,
        location_id,
        region_id,
        start_date,
        end_date,
        purchases_in_conversion
      }
    };

    const res = yield call(axios.get, url.href, {
      params: url.params
    });

    if (!res.data) {
      yield put({type: FETCH_FUNNEL_INTRO_OFFERS_CHART_SUCCESS, payload: null});
      return;
    }

    if (has(res, "data.first_data_date")) {
      yield put({type: ADD_ALL_TIME_RANGE_SUCCESS, payload: res.data.first_data_date});
    }

    const result = {
      ...res.data,
      combinedStats: combineStats(res.data.primaryStats, res.data.secondaryStats),
      chart: {
        label: res.data.chart.label,
        data: formatIntroFunnelChartData(res.data.chart)
      }
    };

    yield put({type: FETCH_FUNNEL_INTRO_OFFERS_CHART_SUCCESS, payload: result});
  } catch (error) {
    console.error(error);
    yield put({type: FETCH_FUNNEL_CHART_FAILURE, error});
  }
}

export function* fetchReferralTableData(args) {
  const {
    organization_id,
    object_id,
    location_id,
    region_id,
    start_date,
    end_date,
    start_from_appointment,
    purchases_in_conversion,
    show_future_appointment
  } = args;

  try {
    const url = {
      href: CONSTANTS.REQUEST_HREF.FUNNEL_TABLE,
      params: {
        organization_id,
        object_id,
        location_id,
        region_id,
        start_date,
        end_date,
        start_from_appointment,
        purchases_in_conversion,
        show_future_appointment
      }
    };

    const res = yield call(axios.get, url.href, {
      params: url.params
    });

    if (has(res, "data.first_data_date")) {
      yield put({type: ADD_ALL_TIME_RANGE_SUCCESS, payload: res.data.first_data_date});
    }

    yield put({type: FETCH_REFERRAL_TABLE_SUCCESS, payload: res.data});
  } catch (error) {
    console.error(error);
    yield put({type: FETCH_REFERRAL_TABLE_FAILURE, error});
  }
}
